export const STATUS_CONCILIACAO = {
  PENDENTE: '0',
  EM_ANDAMENTO: '1',
  CONCLUIDA: '2',
  CANCELADA: '3',
  ERRO: '4'
}

export function getLabelStatusConciliacao(status) {
  const labels = {
    [STATUS_CONCILIACAO.PENDENTE]: 'Pendente',
    [STATUS_CONCILIACAO.EM_ANDAMENTO]: 'Em Andamento',
    [STATUS_CONCILIACAO.CONCLUIDA]: 'Concluida',
    [STATUS_CONCILIACAO.CANCELADA]: 'Cancelada',
    [STATUS_CONCILIACAO.ERRO]: 'Erro'
  }
  return labels[String(status)] || String(status || '')
}

export function getVariantStatusConciliacao(status) {
  const variants = {
    [STATUS_CONCILIACAO.PENDENTE]: 'secondary',
    [STATUS_CONCILIACAO.EM_ANDAMENTO]: 'info',
    [STATUS_CONCILIACAO.CONCLUIDA]: 'success',
    [STATUS_CONCILIACAO.CANCELADA]: 'danger',
    [STATUS_CONCILIACAO.ERRO]: 'warning'
  }
  return variants[String(status)] || 'secondary'
}

export function getOptionsStatusConciliacao() {
  return [
    { value: '', text: 'Todos' },
    { value: STATUS_CONCILIACAO.PENDENTE, text: 'Pendente' },
    { value: STATUS_CONCILIACAO.EM_ANDAMENTO, text: 'Em Andamento' },
    { value: STATUS_CONCILIACAO.CONCLUIDA, text: 'Concluida' },
    { value: STATUS_CONCILIACAO.CANCELADA, text: 'Cancelada' },
    { value: STATUS_CONCILIACAO.ERRO, text: 'Erro' }
  ]
}



// WEBPACK FOOTER //
// ./src/utils/conciliacaoStatus.js